import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import {
  DataTable,
  Field,
  CurrencyField,
  DateTimeField,
} from '../../../commons/DataTable';
import { useAuth } from '../../../commons/Auth';
import CommercialBilledField from '../../../commons/DataTable/CommercialBilledField';
import IAFCustomCheckboxesInsurances from '../../../commons/Checkboxes/IAFCustomCheckboxesInsurance';
import CustomerVatCodeField from '../../../commons/DataTable/CustomerVatCodeField';
import CustomerTypeField from '../../../commons/DataTable/CustomerTypeField';
import CommercialField from '../../../commons/DataTable/CommercialField';
import { USER_ADMIN_TYPES } from '../../../App';
import CustomerNameField from '../../../commons/DataTable/CustomerNameField';
import FieldIafNumber from '../../../commons/DataTable/FieldIafNumber';

function InsurancesRoyaltyTable({
  dataTable,
  data,
  total = 0,
  query = {},
  onFilter,
  isLoading,
  bottomRow,
  showEmptyTableMessage,
  truncateTable,
  onSelectChange,
  allowedRoles = [],
  profile = {},
}) {
  const [t] = useTranslation('COMMON');
  const [{ newIsAdmin, newUserType = '' }] = useAuth();
  const { offset, limit } = query;

  const onCheck = (report) => {
    if (!allowedRoles.includes('superadmin')) {
      return;
    }
    onSelectChange(report);
  };

  return (
    <DataTable
      offset={offset}
      limit={limit}
      total={total}
      dataTable={dataTable}
      data={data}
      isLoading={isLoading}
      loadingText={t('LOADING')}
      emptyText={t('NO_DATA')}
      onFilter={onFilter}
      bottomRow={bottomRow}
      showEmptyTableMessage={showEmptyTableMessage}
    >
      {!truncateTable &&
        (newIsAdmin ? (
          <IAFCustomCheckboxesInsurances
            onSelectChange={onCheck}
            onClick={(e) => e.stopPropagation()}
            profile={profile}
          />
        ) : (
          <></>
        ))}
      <Field title="Rami" source="branch" visible={!truncateTable} />

      <Field
        title="Codice polizza"
        source="policy_code"
        visible={!truncateTable}
      />

      <Field
        title="Etichetta polizza"
        source="insurance_code"
        visible={!truncateTable}
      />

      <Field
        title="Referente"
        source="admin.businessName"
        className="text-left"
        visible={!truncateTable}
      />
      <Field
        title="Nome Fornitore"
        source="supplier.businessName"
        className="text-left"
        visible={!truncateTable}
      />
      <Field
        title="Tipo agenzia"
        source="agencyType"
        className="text-left"
        visible={!truncateTable}
      />
      <CustomerNameField
        title="Cliente"
        source="customer.name"
        visible={!truncateTable}
      />
      <CustomerVatCodeField
        title="P.Iva / Codice fiscale cliente"
        visible={!truncateTable}
      />
      <CustomerTypeField
        title="Tipologia cliente"
        source="customerType"
        visible={!truncateTable}
      />
      <DateTimeField
        title="Data inizio"
        source="start_date"
        format="DD/MM/YYYY"
        visible={!truncateTable}
      />
      <DateTimeField
        title="Data fine"
        source="end_date"
        format="DD/MM/YYYY"
        visible={!truncateTable}
      />
      <Field title="Fraz" source="fraz" visible={!truncateTable} />
      <CurrencyField
        title="Imponibile"
        source="net"
        className="txt-table-right"
      />
      <CurrencyField
        title="Importo da incassare"
        source="gross"
        className="txt-table-right"
      />
      <CommercialField
        title="Posizione Commerciale"
        source="commercialPosition"
        className="txt-table-center"
        visible={!truncateTable && newUserType === USER_ADMIN_TYPES.SUPER_ADMIN}
      />
      <CurrencyField
        title={`Quota commerciale`}
        source="commercialShare"
        className="txt-table-right"
      />
      <CurrencyField
        title="Quota commerciale maturata"
        source="earnedCommercialShare"
        className="txt-table-right"
      />
      <CurrencyField
        title="Diritto a Fatturare"
        source="billableCommercialShare"
        className="txt-table-right"
      />
      <CommercialBilledField
        title="Invitato a Fatturare"
        className="txt-table-right"
        visible={!truncateTable}
      />
      <FieldIafNumber
        title="Numero IAF"
        className="txt-table-right"
        source="iafs.0.number"
        visible={!truncateTable}
      />
    </DataTable>
  );
}

export default withRouter(InsurancesRoyaltyTable);
